<template lang="html">

  <div>

    <router-link v-if="!!!external" class="row-start arrow-link" :to="to" :target="(blank) ? '_blank' : '_self'">

      <span>{{text}}</span>

      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 31.49 31.49" style="enable-background:new 0 0 31.49 31.49;" xml:space="preserve" width="30px" height="30px">
        <path d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111  C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587  c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"/>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
      </svg>

    </router-link>



    <a v-if="!!external" class="row-start" :href="to" :target="(blank) ? '_blank' : '_self'">

      <span>{{text}}</span>

      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 31.49 31.49" style="enable-background:new 0 0 31.49 31.49;" xml:space="preserve" width="30px" height="30px">
        <path d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111  C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587  c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"/>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
        <g>
        </g>
      </svg>

    </a>

  </div>


</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'add',
    props: ['text', 'to', 'blank', 'external'],
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        style : 'getStyles'
      })
    }
  }
</script>

<style scoped lang="scss">
@import '@/assets/css/colors.scss';
span{
  font-size: 14px;
  text-transform: uppercase;
  margin-right: 5px;
  font-weight: 700;
}

svg{
  width: 15px;
}
.listado-encuestas .arrow-link span{
  text-transform: initial;
  color: $primary;
  font-size: 16px;
}
.listado-encuestas .arrow-link svg{
  fill: $primary;
}
</style>



// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/parts/icons/arrow-link.vue